<template>
    <section>
        <div class="relative z-10 max-w-screen-xl px-4 mb-20 mx-auto">
            <!-- FAQ Header -->
            <div class="max-w-max mx-auto relative mb-6">
                <NuxtImg src="/images/circuit.png" width="200" height="120" alt="Shopping Bag" class="mx-auto" loading="lazy" />
                <div
                    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-[image:var(--primary-gradient)]">
                    <NsFaqIcon />
                </div>
            </div>

            <!-- Heading -->
            <h2 class="text-2xl sm:text-3xl md:text-4xl text-[var(--text-secondary)] text-center font-bold -mt-6 mb-8">
                FAQ
            </h2>

            <!-- Accordion -->
            <Accordion :value="0" class="space-y-4 max-w-2xl sm:max-w-3xl lg:max-w-5xl mx-auto">
                <AccordionPanel v-for="(faq, index) in faqs" :key="index" :value="index"
                    class="!border !border-[var(--border-primary)] rounded-lg overflow-hidden !bg-[var(--background-card)]">
                    <!-- Header -->
                    <AccordionHeader :pt="{
                        toggleIcon: { class: '!text-[var(--text-primary)] !font-bold' },
                        root: {
                            class:
                                '!text-[var(--text-secondary)] text-base sm:text-lg md:text-xl font-semibold',
                        },
                    }" class="!bg-[var(--background-card)] px-4 sm:px-6 py-3 sm:py-4">
                        {{ faq.question }}
                    </AccordionHeader>

                    <!-- Content -->
                    <AccordionContent :pt="{
                        content: {
                            class:
                                'pt-2 pb-4 px-4 sm:px-6 text-sm sm:text-base md:text-lg !bg-[var(--background-card)] !text-[var(--text-gray)]',
                        },
                    }">
                        {{ faq.answer }}
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>
        </div>
    </section>
</template>

<script setup lang="ts">
const NsFaqIcon = defineAsyncComponent(() =>
    import("~/components/atoms/icons/NsFaqIcon.vue")
);

const faqs = [
    {
        question: "Can I Use The Frontend With Another Backend?",
        answer:
            "No, this frontend is designed exclusively for our backend to ensure optimal performance and integration.",
    },
    {
        question: "How Is The Frontend Updated?",
        answer:
            "Our frontend is regularly updated to incorporate new features and improvements, keeping it in sync with the backend.",
    },
    {
        question: "What Kind Of Support Is Available?",
        answer:
            "We offer comprehensive support, including setup assistance, troubleshooting, and updates.",
    },
];
</script>
